{
  "page": {
    "title": "Administration",
    "tabs": {
      "users": "Utilisateurs",
      "scraping": "Tâches de collecte",
      "mortgage": "Hypothèque",
      "translations": "Traductions"
    },
    "createUser": "Créer un utilisateur",
    "failedToLoadUsers": "Échec du chargement des utilisateurs",
    "userUpdated": "Utilisateur mis à jour avec succès",
    "userCreated": "Utilisateur créé avec succès",
    "failedToSaveUser": "Échec de l'enregistrement de l'utilisateur",
    "userDeleted": "Utilisateur « {{username}} » supprimé avec succès",
    "failedToDeleteUser": "Échec de la suppression de l'utilisateur",
    "scrapingStarted": "Tâche de collecte démarrée avec succès",
    "deleteUserTitle": "Supprimer l'utilisateur",
    "deleteUserMessage": "Voulez-vous vraiment supprimer l'utilisateur « {{username}} » ? Cette action est irréversible."
  },
  "userList": {
    "loading": "Chargement des utilisateurs...",
    "noUsers": "Aucun utilisateur trouvé",
    "active": "Actif",
    "inactive": "Inactif",
    "notificationsEnabled": "Notifications activées",
    "notificationsDisabled": "Notifications désactivées",
    "created": "Créé le : {{date}}",
    "createdColumn": "Créé",
    "never": "Jamais",
    "username": "Nom d'utilisateur",
    "email": "E-mail",
    "role": "Rôle",
    "status": "Statut",
    "emailNotifications": "Notifications par e-mail",
    "lastLogin": "Dernière connexion",
    "actions": "Actions",
    "editUser": "Modifier {{username}}",
    "deleteUser": "Supprimer {{username}}",
    "editUserTooltip": "Modifier l'utilisateur",
    "deleteUserTooltip": "Supprimer l'utilisateur"
  },
  "userForm": {
    "editTitle": "Modifier l'utilisateur",
    "createTitle": "Créer un nouvel utilisateur",
    "usernameLabel": "Nom d'utilisateur",
    "usernameError": "Le nom d'utilisateur doit comporter au moins 3 caractères",
    "emailLabel": "E-mail",
    "emailError": "Une adresse e-mail valide est requise",
    "passwordLabel": "Mot de passe",
    "passwordEditLabel": "Mot de passe (laisser vide pour conserver l'actuel)",
    "passwordRequired": "Le mot de passe est requis pour les nouveaux utilisateurs",
    "passwordLength": "Le mot de passe doit comporter au moins 8 caractères",
    "passwordHelper": "Minimum 8 caractères",
    "roleLabel": "Rôle",
    "roleUser": "Utilisateur",
    "roleAdmin": "Administrateur",
    "activeLabel": "Actif",
    "emailNotificationsLabel": "Notifications par e-mail",
    "saving": "Enregistrement...",
    "save": "Enregistrer"
  },
  "mortgage": {
    "title": "Paramètres par défaut de la simulation hypothécaire",
    "description": "Paramètres par défaut utilisés pour calculer la simulation de capacité d'achat affichée sur les pages de détail des annonces. Chaque valeur peut être surchargée par annonce dans la simulation elle-même.",
    "failedToLoad": "Échec du chargement des paramètres hypothécaires",
    "failedToSave": "Échec de l'enregistrement des paramètres hypothécaires",
    "saved": "Paramètres hypothécaires mis à jour avec succès",
    "saving": "Enregistrement...",
    "save": "Enregistrer",
    "fields": {
      "min_down_payment_rate": "Apport personnel minimum (%)",
      "max_down_payment": "Apport personnel maximum (CHF)",
      "annual_income": "Revenu annuel du ménage (CHF)",
      "interest_rate": "Taux d'intérêt (%)",
      "term_years": "Durée fixe (années)",
      "maintenance_rate": "Entretien et charges (%)",
      "purchase_costs_rate": "Frais d'acquisition (%)",
      "amortization_target_ltv": "LTV cible d'amortissement (%)",
      "amortization_years": "Durée d'amortissement (années)",
      "stress_test_rate": "Taux de test de résistance (%)",
      "max_effort_ratio": "Taux d'effort maximum (%)"
    }
  },
  "translations": {
    "title": "Traductions des annonces",
    "description": "Les titres et descriptions courtes des annonces sont traduits immédiatement à l'import ; les descriptions complètes sont traduites à la demande, lors de la première ouverture de l'annonce.",
    "failedToLoad": "Échec du chargement du statut de traduction",
    "failedToStart": "Échec du démarrage de la retraduction",
    "started": "Retraduction démarrée — ceci s'exécute en arrière-plan.",
    "provider": "Fournisseur",
    "disabled": "désactivé",
    "adsInScope": "Annonces concernées",
    "pending": "En attente",
    "failed": "Échouées",
    "usage": "Utilisation du fournisseur : {{used}} / {{limit}} caractères",
    "refresh": "Actualiser",
    "dropAndRetranslate": "Supprimer et retraduire",
    "confirmTitle": "Supprimer et retraduire les annonces",
    "confirmMessage_one": "Cette action supprimera la traduction de titre/description en cache pour {{count}} annonce actuellement concernée (active, ni écartée/pas intéressée/achetée/retirée) et la retraduira en arrière-plan. La description complète en cache reste inchangée — elle est traduite à la demande lors de la prochaine ouverture de l'annonce.",
    "confirmMessage_many": "Cette action supprimera les traductions de titre/description en cache pour les {{count}} annonces actuellement concernées (actives, ni écartées/pas intéressé/achetées/retirées) et les retraduira en arrière-plan. Les descriptions complètes en cache restent inchangées — elles sont traduites à la demande lors de la prochaine ouverture de chaque annonce.",
    "confirmMessage_other": "Cette action supprimera les traductions de titre/description en cache pour les {{count}} annonces actuellement concernées (actives, ni écartées/pas intéressé/achetées/retirées) et les retraduira en arrière-plan. Les descriptions complètes en cache restent inchangées — elles sont traduites à la demande lors de la prochaine ouverture de chaque annonce.",
    "confirmMessageUsage": " Utilisation actuelle du fournisseur : {{used}} / {{limit}} caractères."
  },
  "scraping": {
    "controls": {
      "automaticTitle": "Collecte automatique",
      "loadingSchedule": "Chargement de la planification…",
      "enabled": "Activée",
      "disabled": "Désactivée",
      "nextRun": "Prochaine exécution : {{date}}",
      "frequency": "Fréquence",
      "firstRunAt": "Première exécution le",
      "firstRunHelper": "Définissez la date/heure de la première collecte. Les exécutions suivantes suivent l'intervalle de fréquence à partir de cette heure.",
      "manualTitle": "Contrôles de collecte manuelle",
      "manualDescription": "Déclenchez manuellement une collecte pour un site spécifique ou tous les sites.",
      "starting": "Démarrage...",
      "runNow": "Exécuter maintenant",
      "emailTitle": "Notifications par e-mail",
      "sendNotificationTitle": "Envoyer un e-mail de notification",
      "sendNotificationDescription": "Envoyer manuellement un e-mail de notification à tous les utilisateurs abonnés avec les nouvelles annonces et celles en attente",
      "sending": "Envoi...",
      "sendNow": "Envoyer maintenant",
      "scrapers": {
        "all": {
          "label": "Tous les sites",
          "description": "Lancer la collecte pour tous les sites configurés"
        },
        "immobilier_ch": {
          "label": "Immobilier.ch",
          "description": "Plateforme immobilière suisse"
        },
        "homegate_ch": { "label": "Homegate.ch", "description": "Plateforme immobilière suisse" },
        "comparis_immobilier": {
          "label": "Comparis",
          "description": "Plateforme de comparaison suisse"
        },
        "properstar_ch": {
          "label": "Properstar.ch",
          "description": "Portail immobilier international"
        },
        "anibis_ch": {
          "label": "Anibis.ch",
          "description": "Plateforme suisse de petites annonces"
        },
        "immoscout24_ch": {
          "label": "ImmoScout24.ch",
          "description": "Plateforme immobilière suisse"
        },
        "newhome_ch": {
          "label": "Newhome.ch",
          "description": "Plateforme immobilière suisse"
        }
      }
    },
    "jobList": {
      "status": "Statut",
      "scraper": "Site",
      "all": "Tous",
      "running": "En cours",
      "completed": "Terminée",
      "partial": "Partielle",
      "failed": "Échouée",
      "refresh": "Actualiser",
      "noJobs": "Aucune tâche de collecte trouvée",
      "started": "Démarré : {{date}}",
      "duration": "Durée : {{duration}}",
      "scraped": "Collectées : {{count}}",
      "imported": "Importées : {{count}}",
      "updated": "Mises à jour : {{count}}",
      "retired": "Retirées : {{count}}",
      "id": "ID",
      "startedColumn": "Démarré",
      "durationColumn": "Durée",
      "scrapedColumn": "Collectées",
      "importedColumn": "Importées",
      "updatedColumn": "Mises à jour",
      "retiredColumn": "Retirées",
      "duplicatesColumn": "Doublons",
      "trigger": "Déclencheur",
      "actions": "Actions",
      "viewLogs": "Voir les journaux",
      "restartScraping": "Relancer la collecte",
      "allSites": "Tous les sites"
    },
    "logViewer": {
      "title": "Journaux d'exécution de la collecte",
      "close": "Fermer",
      "runDetails": "Détails de l'exécution",
      "runId": "ID d'exécution : {{id}}",
      "started": "Démarré : {{date}}",
      "searchPlaceholder": "Rechercher dans les journaux...",
      "logLevel": "Niveau de journal",
      "noLogsMatch": "Aucun journal ne correspond à vos filtres",
      "noLogsAvailable": "Aucun journal disponible pour cette exécution",
      "showingLines_one": "Affichage de {{count}} ligne",
      "showingLines_many": "Affichage de {{count}} lignes",
      "showingLines_other": "Affichage de {{count}} lignes",
      "filtered": " (filtré)"
    }
  }
}
